import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import Helper from '../../utilities/helper';
import { PermissionsGate } from '../../utilities/PermissionsGate';
import { ACCESS_VALUES, PageNames } from '../../utilities/constValues';
import { PermissionsRequired } from '../Shared/PermissionsRequired';
import { Hero } from '../Shared/Hero';
import { ErrorBanner } from '../Shared/ErrorBanner';
import { Button, Col, Row } from 'reactstrap';
import { InstantEstimates } from '../Shared/InstantEstimates';
import { useNavigate } from "react-router-dom";
import { ContentBlock } from '../Shared/Content/ContentBlock';
import { ContentBody } from '../Shared/Content/ContentBody';

export const SampleFleets = () => {
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        Helper.setPagePath(location.pathname);
    }, [location]);

    const returnToPage = () => {
        navigate(-1);
    }

    return (
        <PermissionsGate requestedPermission={ACCESS_VALUES.Resources} renderError={<PermissionsRequired showParticipantMsg={true} />} pageName={PageNames.SampleFleets}>
        <div className="sampleFleetsContainer">
            <Hero pageTitle="Fleet Estimator" />
            <ErrorBanner key="sampleFleets" errorCode="form" />
            <Row className="pageAnchorsBody">
                <Row className="pageAnchorsSection">
                    <Col sm={8} className="inPageNav" >
                        <Button className="buttonAsLink backArrow iconPositionLeft" onClick={returnToPage} >Create a Custom Fleet</Button>
                    </Col>
                </Row>
            </Row>
            <ContentBlock className="sampleFleetsSection">
                <ContentBody>
                    <Row>
                        <InstantEstimates />
                    </Row>
                </ContentBody>
            </ContentBlock>
        </div>
        </PermissionsGate>
    )
};
